import { Inject, Injectable } from '@angular/core';
import { HubFeature, PortalType, PortalTypeEnum } from '@ats/api/cm';
import { ClientConfig, ClientService } from '@cm/core/client';
import { Culture, CultureService } from '@cm/core/culture';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
	routeWithContext,
	routeWithContext$,
	routeWithNewCulture,
	routeWithNewCulture$,
} from '../../../../routing/src/lib/functions/routing'; // Relative to avoid dependency issues. To be removed later
import { Environment, SettingsConfig } from '../models';
import { AppEnvironment } from '../models/app-environment.interface';
import { SETTINGS_CONFIG } from '../settings-config.token';

@Injectable({
	providedIn: 'root',
})
export class SettingsService {
	/**
	 * @deprecated
	 * Use CultureService instead
	 */
	readonly existingCultures$!: Observable<Culture[]>;
	/**
	 * @deprecated
	 * Use CultureService instead
	 */
	readonly supportedCultures$!: Observable<Culture[]>;
	/**
	 * @deprecated
	 * Use ClientService instead
	 */
	readonly config$: Observable<ClientConfig>;
	/**
	 * @deprecated
	 * Use CultureService instead
	 */
	readonly culture$: Observable<Culture>;
	/**
	 * @deprecated
	 * Use CultureService instead
	 */
	readonly cultureCode$: Observable<string>;
	/**
	 * @deprecated
	 * Use ClientService instead
	 */
	readonly client$: Observable<string>;
	readonly apiWithContext$: Observable<string>;
	readonly portal: PortalType;
	readonly portalNumeric: PortalTypeEnum;
	readonly api: string;
	readonly cpUrl: string;
	readonly spUrl: string;
	/** @deprecated Use settings.env.environment instead */
	readonly environment: Environment;
	readonly env: AppEnvironment;
	readonly coreFeature: HubFeature.Core | HubFeature.CandidateAccess = HubFeature.Core;

	constructor(
		@Inject(SETTINGS_CONFIG) private readonly config: SettingsConfig,
		private readonly cultureService: CultureService,
		private readonly clientService: ClientService,
	) {
		this.culture$ = this.cultureService.culture$;
		this.cultureCode$ = this.culture$.pipe(map((culture) => culture.code));
		this.client$ = this.clientService.client$;
		this.portal = this.config.portal;
		this.api = this.config.baseUrl;
		this.cpUrl = this.config.cpUrl;
		this.spUrl = this.config.spUrl;
		this.environment = this.config.environment;
		this.env = config.env;
		this.config$ = this.clientService.config$;

		if (this.portal === PortalType.CandidatePortal) {
			this.coreFeature = HubFeature.CandidateAccess;
		}

		switch (this.portal) {
			case PortalType.CandidatePortal:
				this.portalNumeric = PortalTypeEnum.CandidatePortal;
				break;
			case PortalType.InternalPortal:
				this.portalNumeric = PortalTypeEnum.InternalPortal;
				break;
			default:
				this.portalNumeric = PortalTypeEnum.SponsorPortal;
		}

		this.apiWithContext$ = this.cultureService.culture$.pipe(
			map((culture) => `${this.api}/${this.clientService.clientSnapshot}/${culture.code}`),
		);
		this.existingCultures$ = this.cultureService.existingCultures$;
		this.supportedCultures$ = this.cultureService.supportedCultures$;
	}

	/**
	 * @deprecated
	 * Use ClientService instead
	 */
	get clientSnapshot(): string | null {
		return this.clientService.clientSnapshot;
	}

	/**
	 * @deprecated
	 * Use CultureService instead
	 */
	get cultureSnapshot(): string | null {
		return this.cultureService.cultureSnapshot;
	}

	/**
	 * @deprecated
	 * Use CmRoutingService instead
	 */
	routeWithContext(path: string[]): string[] {
		return routeWithContext({
			culture: this.cultureService.cultureSnapshot ?? undefined,
			client: this.clientService.clientSnapshot ?? undefined,
			portal: this.portal,
		})(path);
	}

	/**
	 * @deprecated
	 * Use CmRoutingService instead
	 */
	routeWithContext$(path: string[]): Observable<string[]> {
		return routeWithContext$(this.client$, this.cultureCode$, this.portal)(path);
	}

	/**
	 * @deprecated
	 * Use CmRoutingService instead
	 */
	routeWithNewCulture(path: string[], cultureCode: string): string[] {
		return routeWithNewCulture({
			client: this.clientSnapshot ?? undefined,
			portal: this.portal,
		})(path, cultureCode);
	}

	/**
	 * @deprecated
	 * Use CmRoutingService instead
	 */
	routeWithNewCulture$(path: string[], cultureCode: string): Observable<string[]> {
		return routeWithNewCulture$(this.client$, this.portal)(path, cultureCode);
	}
}
